import CamposPersonalizadosBoard from "common/components/FormikFields/CamposPersonalizadosBoard"
import EtiquetasMultiSelect from "common/components/FormikFields/EtiquetasMultiSelect"
import { CAMPOS_PERSONALISADOS_ENDPOINTS_SLICE } from "common/utils/constants"
import PanelsHeader from "features/Contactos/components/PanelsHeader"
import mapContactoPersonalizadosToApi from "features/Contactos/mappers/mapContactoPersonalizadosToApi"
import { withFormik } from "formik"
import { useTranslation } from "react-i18next"
import * as Yup from "yup"

const FormCamposPersonalizados = ({
  values,
  handleSubmit,
  isValid,
  dirty,
  etiquetas,
  setFieldValue,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  return (
    <>
      <PanelsHeader
        title={t("contactos.editar.dataAdvance.personalyLabel")}
        handleSubmit={handleSubmit}
        disabled={!(isValid && dirty)}
      />

      <div className='mb-3 mr-3 text-left w-100'>
        <label>{t("contactos.editar.dataAdvance.labelLabel")}</label>

        <EtiquetasMultiSelect
          className='w-full'
          value={values?.etiquetas}
          options={etiquetas}
          onChange={(value: $TSMigrationFixMe) =>
            setFieldValue("etiquetas", value)
          }
          canAddOption
        />
      </div>

      <div className='mr-3 text-left w-100'>
        <label>{t("contactos.editar.dataAdvance.customPropertiesLabel")}</label>

        <CamposPersonalizadosBoard
          endpointSlice={CAMPOS_PERSONALISADOS_ENDPOINTS_SLICE.contacto}
          camposPersonalizados={values?.camposPersonalizados}
        />
      </div>
    </>
  )
}

export const validationSchema = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    camposPersonalizados: Yup.array().of(
      Yup.object().shape({
        clave: Yup.string().required(t("errors.nameEmpty")),
        valor: Yup.string().required(t("errors.valueEmpty")),
      })
    ),
  })

const Form = withFormik({
  validateOnMount: true,
  // @ts-expect-error TS(2339): Property 'data' does not exist on type '{}'.
  mapPropsToValues: ({ data }) => {
    return {
      camposPersonalizados: data?.camposPersonalizados,
      etiquetas: data?.etiquetas,
    }
  },
  enableReinitialize: true,
  validationSchema: ({ t }: $TSMigrationFixMe) => validationSchema(t),
  handleSubmit: async (values, { props }) => {
    const payload = mapContactoPersonalizadosToApi(values)
    // @ts-expect-error TS(2339): Property 'updateData' does not exist on type 'obje...
    props.updateData(payload)
  },
})(FormCamposPersonalizados)

export default Form
